import { useEffect, useMemo, useState } from "react";
import useProtectedFileUrl from "../../hooks/useProtectedFileUrl";
import { resolveFileReference } from "../../services/uploadService";
import { getAvatarColorFromName, getProfileInitials } from "../../utils/profileInitials";
import "./ProfileAvatar.css";

export default function ProfileAvatar({
  name = "",
  imageUrl = "",
  storageKey = "",
  className = "",
  style,
  initialsFallback = "?",
  alt = "",
}) {
  const directUrl = useMemo(
    () => resolveFileReference(imageUrl, storageKey),
    [imageUrl, storageKey]
  );
  const protectedUrl = useProtectedFileUrl(imageUrl, storageKey);
  const resolvedUrl = protectedUrl || directUrl;
  const [broken, setBroken] = useState(false);
  const colorFallback = useMemo(() => getAvatarColorFromName(name), [name]);
  const mergedStyle = useMemo(
    () => ({
      background: colorFallback.background,
      color: colorFallback.color,
      ...style,
    }),
    [colorFallback.background, colorFallback.color, style]
  );

  useEffect(() => {
    setBroken(false);
  }, [resolvedUrl, imageUrl, storageKey]);

  const showImage = Boolean(resolvedUrl) && !broken;
  const rootClass = `profile-avatar${className ? ` ${className}` : ""}`;

  return (
    <span className={rootClass} style={mergedStyle} aria-hidden={alt ? undefined : true}>
      {showImage ? (
        <img src={resolvedUrl} alt={alt} onError={() => setBroken(true)} />
      ) : (
        <span className="profile-avatar__initials">{getProfileInitials(name, initialsFallback)}</span>
      )}
    </span>
  );
}
